import { Smartphone } from 'lucide-react';
import { useChannelQuotas } from '@/features/channel-quota/model/use-channel-quotas';
import { ChannelSettingsPage } from '@/features/marketing-shared/ui/channel-settings-page';
import { EmptyState } from '@/shared/components/empty-state';
import { usePassbook } from '@/shared/lib/passbook';
import { Badge } from '@/shared/ui/badge';
import { Card } from '@/shared/ui/card';
import { useSmsMarketing } from '../model/context';

export function SmsSettingsPage() {
  const { idPassbook } = usePassbook();
  const { numbers, numbersState } = useSmsMarketing();
  const { quotas, live } = useChannelQuotas(idPassbook);

  return (
    <ChannelSettingsPage
      title="Envio"
      description="Número remetente e cota de SMS deste passbook. O e-mail tem a cota ao lado."
      phase={numbersState.phase}
      error={numbersState.error}
      onRetry={numbersState.refetch}
      loadingLabel="Carregando a configuração de SMS"
      errorTitle="Não foi possível carregar o envio"
      capacity={quotas?.sms}
      channel="sms"
      capacityTitle="Saldo de SMS"
      unit="SMS"
      live={live}
    >
      {numbers.length === 0 ? (
        <Card>
          <EmptyState
            icon={Smartphone}
            title="Nenhum número de envio"
            description="Os remetentes vêm da conta do provedor (Twilio ou MailerSend) liberada para esta loja pelo time da Fixe. Sem número, a aprovação é recusada."
          />
        </Card>
      ) : (
        <div className="grid gap-3 lg:grid-cols-3">
          {numbers.map((number) => (
            <Card key={number.id} className="p-4">
              <div className="flex items-start justify-between gap-2">
                <h2 className="break-all font-medium">{number.telephoneNumber}</h2>
                <Badge variant={number.paused ? 'warning' : 'success'}>{number.paused ? 'Pausado' : 'Ativo'}</Badge>
              </div>
              <p className="mt-2 text-sm text-muted-foreground">
                {number.paused ? 'Não pode ser remetente enquanto estiver pausado no provedor.' : 'Pode ser o remetente da campanha.'}
              </p>
            </Card>
          ))}
        </div>
      )}
    </ChannelSettingsPage>
  );
}
